import { render, staticRenderFns } from "./service_center_list.vue?vue&type=template&id=57ed2a53"
import script from "./service_center_list.vue?vue&type=script&lang=js"
export * from "./service_center_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports